import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaCcApplePay, FaCcVisa, FaCcMastercard } from "react-icons/fa";
import { SiDiscover } from "react-icons/si";
// import { useAuth } from "../../utils/AuthContext";
import { useAuth } from "../../../utils/AuthContext ";

const FooterLinksAndPayments = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleProtectedNavigation = (route) => {
    if (user) {
      navigate(route);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/sign-in");
    }
  };

  const handlePublicNavigation = (route) => {
    navigate(route);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const footerLinks = [
    { label: "HOME", route: "/", protected: false },
    { label: "CONTACT US", route: "/contact", protected: false },
    { label: "ABOUT US", route: "/about", protected: false },
    { label: "FAQs", route: "/contact", protected: false },
    { label: "MY ORDERS", route: "/orders", protected: true },
    { label: "MY CART", route: "/all-cart-product", protected: true },
    { label: "SAVED ADDRESSES", route: "/addresses", protected: true },
    // { label: "WISH LIST", route: "/wishlist", protected: true },
    // { label: "COMPARE", route: "/comparision", protected: true },
    // { label: "PRIVACY POLICY", route: "/privacy", protected: false },
    { label: "BUYING GUIDE", route: "/buying-guide", protected: false },
    { label: "CAREER", route: "/career", protected: false },
  ];

  return (
    <>
      {/* Footer Links */}
      <div className="bg-[#FCE5DC] rounded-lg">
        <div className="px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
          <div className="flex flex-wrap justify-center lg:justify-between items-center gap-x-4 sm:gap-x-6 gap-y-2 sm:gap-y-3">
            {footerLinks.map((item, index) =>
              item.protected ? (
                <span
                  key={index}
                  onClick={() => handleProtectedNavigation(item.route)}
                  className="text-gray-700 hover:text-orange-500 transition duration-300 text-sm sm:text-base font-medium cursor-pointer uppercase"
                >
                  {item.label}
                </span>
              ) : (
                <span
                  key={index}
                  onClick={() => handlePublicNavigation(item.route)}
                  className="text-gray-700 hover:text-orange-500 transition duration-300 text-sm sm:text-base font-medium cursor-pointer uppercase"
                >
                  {item.label}
                </span>
              )
            )}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#CC5500]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-2">
          <div className="flex flex-col sm:flex-row justify-between items-center text-gray-700 text-xs sm:text-[15px] gap-2">
            <div className="text-center sm:text-left text-white">
              © {new Date().getFullYear()}{" "}
              <span className="font-semibold">BricknBar</span> - All Rights
              Reserved
            </div>
            {/* <div className="text-center sm:text-right">
                Design & Developed by{" "}
                <Link
                  to="#"
                  className="text-orange-500 hover:text-orange-700 font-medium transition duration-300"
                >
                  BricknBar
                </Link>
              </div> */}
            <div className="">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <div></div>
                <div className="flex flex-col items-center sm:items-end">
                  <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
                    <div className="flex items-center justify-center ">
                      <FaCcApplePay className="text-white" size={40} />
                    </div>
                    <div className="flex items-center justify-center p-1">
                      <FaCcVisa className="text-white" size={40} />
                    </div>
                    <div className="flex items-center justify-center p-1">
                      <SiDiscover className="text-white" size={40} />
                    </div>
                    <div className="flex items-center justify-center p-1">
                      <FaCcMastercard className="text-white" size={40} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterLinksAndPayments;
